<template>
  <div id="hres6eu">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres6euIndex"
            searchBoxAlias="approve"
            :maxRowspan="maxRowspan.index"
            :detailEvent="detailEvent"
            :approveEvent="postHres6euSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6eu/mutation-types'
import detail from 'components/hres6eu/detail'
import moment from 'moment'

export default {
  name: 'hres6eu',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHres6euColumnsLabels()
    this.receivedHres6euIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6EU_INDEX_DISP,
      detailDisp: types.GET_HRES6EU_DETAIL_DISP,
      maxRowspan: types.GET_HRES6EU_MAX_ROWSPAN,
      columns: types.GET_HRES6EU_COLUMNS,
      labels: types.GET_HRES6EU_LABELS,
      index: types.GET_HRES6EU_INDEX,
      indexSelected: types.GET_HRES6EU_INDEX_SELECTED,
      detail: types.GET_HRES6EU_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq
      }
      this.receivedHres6euDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6EU_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6EU_PAGE,
      receivedHres6euColumnsLabels: types.RECEIVED_HRES6EU_COLUMNS_LABELS,
      receivedHres6euIndex: types.RECEIVED_HRES6EU_INDEX,
      receivedHres6euDetail: types.RECEIVED_HRES6EU_DETAIL,
      postHres6euSendApprove: types.POST_HRES6EU_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?e308fd14